import { useState } from 'react';
import axios from 'axios';

type UseS3UploadResult = {
  uploading: boolean;
  error: string | null;
  uploadFile: (url: string, file: File, onProgress?: (progress: number) => void) => Promise<void>;
};

export function useS3Upload(): UseS3UploadResult {
  const [uploading, setUploading] = useState<boolean>(false);
  const [error, setError] = useState<string | null>(null);

  async function uploadFile(url: string, file: File, onProgress?: (progress: number) => void): Promise<void> {
    setUploading(true);
    setError(null);

    try {
      await axios.put(url, file, {
        headers: { 'Content-Type': file.type },
        onUploadProgress: event => {
          if (event.total) {
            const percent: number = Math.round((event.loaded * 100) / event.total);
            if (onProgress) {
              onProgress(percent);
            }
          }
        }
      });
    } catch (error: unknown) {
      if (axios.isAxiosError(error)) {
        setError(error.message ?? 'Unknown error');
      } else {
        setError('unexpected error');
      }
    } finally {
      setUploading(false);
    }
  }

  return {
    uploading,
    error,
    uploadFile
  };
}
